import * as Yup from 'yup';
import { victimStatuses } from '../../index.js';
export const victimStatusSchema = Yup
    .string()
    .required('Статус обов\'язковий')
    .oneOf(victimStatuses, 'Статус повинен бути одним зі значень '
    + '[approved, waiting, rejected]');
